import React, { Fragment } from 'react'
import Card from '../components/Card'
import Header from '../components/Header'
import Masthead from '../components/Masthead'
import './index.scss'

const IndexPage = ({ data }) => (
  <div className="page">
    <Header />
    <Masthead />
    <main>
      <div className="card-wrapper">
        {data.allMetaDataJson.edges.map(image => (
          <Card data={image.node} key={image.node.fullName} />
        ))}
      </div>
    </main>
  </div>
)

export const svgQuery = graphql`
  query images {
    allMetaDataJson {
      edges {
        node {
          color
          fullName
          logo {
            id
            publicURL
          }
        }
      }
    }
  }
`

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js